'use client';

import { CmsOverlayDialogContent } from '@/cms/components/overlays/cms-overlay-dialog-content';
import { Loader2 } from '@/components/icons/app-icons';
import {
  Dialog,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/overlay/dialog';
import type { SiteRuntimeTaskPaymentDialogCopy } from '@/site-runtime/code-owned/task-payment-dialog-copy';
import { type ReactNode, useRef } from 'react';

export function SiteRuntimeTaskPaymentDialogShell({
  copy,
  locale,
  onClose,
  title,
  children,
}: {
  copy: SiteRuntimeTaskPaymentDialogCopy;
  locale: string;
  onClose: () => void;
  title?: string;
  children?: ReactNode;
}) {
  const dialogRef = useRef<HTMLDivElement>(null);
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <CmsOverlayDialogContent
        ref={dialogRef}
        closeButtonLabel={copy.close}
        dir={locale === 'ar' ? 'rtl' : 'ltr'}
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          dialogRef.current?.focus();
        }}
        className="max-h-full gap-6 overflow-y-auto border-[var(--cms-outline-soft)] bg-[var(--cms-workspace-surface-panel)] px-6 pt-10 pb-6 text-center text-[var(--color-on-surface)] shadow-[var(--cms-shadow-panel)] sm:max-w-sm sm:px-8"
        data-site-runtime-task-payment
      >
        <DialogTitle className="text-xl leading-snug text-balance">
          {title ?? copy.title}
        </DialogTitle>
        {children ?? (
          <>
            <DialogDescription>{copy.disclosure}</DialogDescription>
            <output className="flex items-center justify-center gap-2 text-sm">
              <Loader2
                aria-hidden="true"
                className="size-4 animate-spin motion-reduce:animate-none"
              />
              {copy.preparingQuote}
            </output>
          </>
        )}
      </CmsOverlayDialogContent>
    </Dialog>
  );
}
